import { RootState } from "./root/index";
import IProduct from "@/models/protocols/IProduct";
import User from "@/models/User";
import { Cart } from "@/types/Cart";
import Vue from "vue";
import Vuex from "vuex";
import Root from "./root";

export interface State {
  Root: RootState;
}

Vue.use(Vuex);

const modules = {
  Root,
};

const store = new Vuex.Store<State>({
  modules,
});

export default store;
